import { storage } from './utils/storage.js';

export const DEFAULT_CONFIG = {
  provider: 'openai',
  baseURL: 'https://api.openai.com/v1',
  apiKey: '',
  model: 'gpt-4.1-mini',
  temperature: 0.7,
  difficulty: 'medium',
  field: 'any',
  gameMode: 'celebrity',
  saveApiKey: false,
  stealthMode: false,
  stealthTheme: 'dark',
};

export function loadConfig() {
  const config = {};
  for (const [key, defaultValue] of Object.entries(DEFAULT_CONFIG)) {
    const stored = storage.config.get(key);
    config[key] = stored !== null ? stored : defaultValue;
  }

  // API Key 若保存过，进行 base64 解码
  if (config.saveApiKey && config.apiKey) {
    try {
      config.apiKey = atob(config.apiKey);
    } catch {
      config.apiKey = '';
    }
  } else if (!config.saveApiKey) {
    config.apiKey = '';
  }

  return config;
}

export function saveConfig(config) {
  const toSave = { ...config };

  if (config.saveApiKey && config.apiKey) {
    toSave.apiKey = btoa(config.apiKey);
  } else {
    toSave.apiKey = '';
  }

  for (const [key, value] of Object.entries(toSave)) {
    storage.config.set(key, value);
  }
}

export function buildLLMConfig(config) {
  return {
    provider: config.provider,
    baseURL: config.baseURL,
    apiKey: config.apiKey,
    model: config.model,
    temperature: config.temperature,
  };
}
